import { useMutation } from '@tanstack/react-query';
import { uploadDeliveredOrderPhoto } from '../services';

const useUploadDeliveredOrderPhoto = () => {
  return useMutation({
    mutationKey: ['uploadDeliveredOrderPhoto'],
    mutationFn: async (payload) => await uploadDeliveredOrderPhoto(payload),
    retry: 3,
  });
};

export default useUploadDeliveredOrderPhoto;
